<template>
  <div :class="classes">
    <pt-sub-title title="海报信息"></pt-sub-title>
    <pt-form-item label="海报名称：" :labelWidth="labelWidth" :required="true">
      <el-input name="base.name" data-vv-as="海报名称" v-validate="'required'" v-model="formData.name" placeholder="请输入海报名称"></el-input>
    </pt-form-item>
    <pt-form-item label="海报图：" :labelWidth="labelWidth"  :required="true">
      <wt-upload-file accept="image/png,image/jpeg" :action="uploadApi" :data="picture_params" path-url-name="url" :img-url="publicResourcesUrl"
        v-model="formData.imageUrl" :multiple="false" :class="$style['upload-picture']" data-vv-as="海报图" v-validate="'required'">
          <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
      </wt-upload-file>
      <ul :class="$style.pictureNames">
        <li v-for="(item,index) in formData.imageUrl" :key="index">{{item.name}}</li>
      </ul>
      <div :class="$style['upload-tips-text']"  class="gray-color">*建议尺寸：680*900像素；图片格式：jpg、png</div>
    </pt-form-item>
    <pt-form-item label="选择海报类型：" :labelWidth="labelWidth"  :required="true">
      <poster-type-selector data-vv-as="海报类型" v-validate="'required'" v-model="formData.type"></poster-type-selector>
    </pt-form-item>
    <pt-form-item label="在工具中心展示：" :labelWidth="labelWidth" :required="true">
      <el-switch v-model="formData.visibleInTools"></el-switch>
    </pt-form-item>
    <pt-form-item label="适用商品：" :labelWidth="labelWidth"  :required="true" v-if="formData.type==='GOODS'">
      <el-button type="primary" plain @click="selectGoods">点击选择</el-button><br/>
      <wt-input :value="formData.goodsId" style="display:none"  data-vv-as="适用商品" name="name"  v-validate="'required'"></wt-input>
      <good-table :goodsData="goodsData"></good-table>
    </pt-form-item>
    <pt-form-item label="海报主题色：" :labelWidth="labelWidth" :required="true">
      <el-color-picker data-vv-as="海报主题色" v-validate="'required'" v-model="formData.themeColor"></el-color-picker>
    </pt-form-item>
    <pt-form-item label="二维码右侧文字：" :labelWidth="labelWidth" :required="true">
      <el-input type="textarea" autosize v-model="formData.rightText" name="formData.rightText" data-vv-as="二维码右侧文字"  v-validate="'required'" placeholder="请输入二维码右侧文字"></el-input>
      <!-- <span class="gray-color">*限制16个字符</span> -->
    </pt-form-item>
    <!-- 选择商品 -->
    <el-dialog :visible="showDialog"  :title="dialog_title" @close="closeDialog"  :class="$style['goods-dialog']">
      <coupon-for-goods selectType='radio' :isRadioSelectButton="true" @selectGoodsSubmit="selectGoodsSubmit" @close="closeDialog" :selected-goods="goodsData"></coupon-for-goods>
    </el-dialog>
  </div>
</template>

<script>
import couponForGoods from 'cps/mall-manage/select-for-goods'
import formMixins from 'mixins/form'
import posterTypeSelector from './poster-type-selector'
import goodTable from './good-table'
// 组件class前缀
const prefixCls = 'pt-poster-form'

export default {
  name: 'pt-poster-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${this.$style[prefixCls]}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  components: { posterTypeSelector, couponForGoods, goodTable },
  data () {
    return {
      formData: this.value ? this.value : {
        rightText: '',
        type: 'GOODS',
        visibleInTools: false
      },
      labelWidth: '150px',
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'poster'
      },
      publicResourcesUrl: this.$publicResourcesUrl,
      showDialog: false,
      dialog_title: '',
      goodsData: {}
    }
  },
  watch: {
    value (val) {
      if (val.goodsData) {
        this.$set(this, 'goodsData', val.goodsData)
      }
      this.formData = val
    }
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
    },
    selectGoods () {
      this.dialog_title = '选择商品'
      this.showDialog = true
    },
    selectGoodsSubmit (val) {
      console.log('this.formData======val====', JSON.parse(JSON.stringify(val)))
      if (JSON.parse(JSON.stringify(val)).goodsDTO && JSON.parse(JSON.stringify(val)).goodsDTO.goodsData && JSON.parse(JSON.stringify(val)).goodsDTO.goodsData.name) {
        this.$set(this.formData, 'goodsId', JSON.parse(JSON.stringify(val)).goodsDTO.goodsData.goodsId)
        this.$set(this.formData, 'goodsName', JSON.parse(JSON.stringify(val)).goodsDTO.goodsData.name)
      }
      this.$set(this, 'goodsData', JSON.parse(JSON.stringify(val)))
      this.closeDialog()
    },
    closeDialog () {
      this.showDialog = false
    }

  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-poster-form{
  :global{
      .form-item .el-input,.el-input__inner{
        max-width: 2.8rem;
      }
      .form-item .el-input--suffix .el-input__inner{
        min-width: 2.8rem;
      }
      .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 170px;
        height: 225px;
      }
      el-textarea,.el-textarea__inner{
        width:500px;
      }
      .wt-upload-file{
        line-height: 0;
        margin-top: 10px;
      }
      .el-upload-list{
        max-width: 800px;
      }
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
  .upload-file-text{
    line-height: 225px;
  }

}

.goods-dialog{
   :global
    .el-dialog{
        width: 70%;
        max-width: 1000px;
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }
}
</style>
